import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import CategoriesGql from '@/extensions/eventManager/store/graphql/queries/Categories.gql';
import CategoryGql from '@/extensions/eventManager/store/graphql/queries/Category.gql';
import CategoriesPaginatedGql from '@/extensions/eventManager/store/graphql/queries/CategoriesPaginated.gql';
import CreateCategoryGql from '@/extensions/eventManager/store/graphql/mutations/CreateCategory.gql';
import UpdateCategoryGql from '@/extensions/eventManager/store/graphql/mutations/UpdateCategory.gql';
import DeleteCategoryGql from '@/extensions/eventManager/store/graphql/mutations/DeleteCategory.gql';

export default {
    fetchList: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: CategoriesGql,
                    variables
                })
                .then(({ data }) => resolve(data.EX_EVNT_Categories))
                .catch(err => reject(err));
        }),
    fetchCategoriesPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: CategoriesPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'id'),
                        direction: _.get(data, 'variables.direction', 'asc'),
                        link: _.get(data, 'link.route', '/event-manager/category/'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.EX_EVNT_CategoriesPaginated))
                .catch(err => reject(err));
        }),
    fetchCategory: id => {
        if (id === undefined) throw new Error('required argument is missing');

        let variables = { id: parseInt(id) };

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CategoryGql,
                    variables
                })
                .then(({ data }) => resolve(data.EX_EVNT_Category))
                .catch(err => reject(err));
        });
    },
    create: category => {
        if (category === undefined) throw new Error('required argument is missing');

        category = _.removeDeepByKey(category, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateCategoryGql,
                    variables: { category }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_EVNT_CreateCategory);
                })
                .catch(err => reject(err));
        });
    },
    update: category => {
        if (category === undefined) throw new Error('required argument is missing');

        category = _.removeDeepByKey(category, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateCategoryGql,
                    variables: { category }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_EVNT_UpdateCategory);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteCategoryGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_EVNT_DeleteCategory);
                })
                .catch(err => reject(err));
        });
    }
};
